<template>
    <Dialog 
          :header="formMode == 'edit' ? 'Chỉnh sửa loại đơn vị': 'Thêm mới loại đơn vị'"
          :visible.sync="displayDialog"
          :contentStyle="{overflow: 'visible'}"
          :style="{width: '50vw'}"
          :class="'popup-dialog'"
          :modal="true"
        >
        <div class="p-fluid">
            <div class="p-col-12 form-popup-custom">
                <div class="p-field">
                    <label>Loại đơn vị <span class="error">*</span></label>
                </div>
                <div class="p-field">
                    <InputText maxlength="255" id="name" type="text" v-model="name" :placeholder="'Nhập loại đơn vị'"/>
                    <small v-if="validationErrors && validationErrors['name']"
                        class="p-invalid" >{{validationErrors['name']}}</small>
                    <small v-if="name_exists"
                    class="p-invalid" >Loại đơn vị bị trùng</small>
                </div>
            </div>
            <div class="p-col-12 form-popup-custom">
              <div class="p-grid">
              <div class="p-col-6">
                <div class="p-field">
                  <label>Số đơn vị cấp con</label>
                </div>
                <div class="p-field">
                  <InputNumber  type="text" :min="-1" v-model="number_of_subunits"/>
                </div>
              </div>
              <div class="p-col-6">
                <div class="p-field">
                  <label>Số tài khoản con</label>
                </div>
                <div class="p-field">
                  <InputNumber  id="number_of_accounts" type="text" :min="-1" v-model="number_of_accounts"/>
                </div>
              </div>
              </div>

            </div>
            <div class="p-col-12 form-popup-custom">
                <div class="p-field">
                    <div class="p-field-checkbox">
                        <Checkbox  v-model="status" :binary="true"/>
                        <label >Hiển thị sử dụng</label>
                    </div>
                </div>
            </div>
           
        </div>
        <template #footer>
            <Button :disabled="submitForm" class="p-button-success"  :label="formMode == 'edit' ? 'Lưu' : 'Tạo'" @click="saveData" />
        </template>
      </Dialog>
</template>

<script>
import DataServices from '@/core/DataServices'

export default {
  props: {
    show: Boolean,
    mode: String,
    modelName: String,
    model: Object
  },
  data() {
    return {
        name: '',
        status: true,
        displayDialog: this.show,
        validationErrors: {},
        name_exists: false,
        submitForm: false,
        number_of_accounts: 0,
        number_of_subunits: 0,
    }
  },
  created() {
    this.formMode = this.mode;
    if (this.formMode === 'edit'  && this.model !== undefined && this.model !== null && Object.entries(this.model).length) {
      this.name = this.model.name;
      this.number_of_accounts = this.model.number_of_accounts;
      this.number_of_subunits = this.model.number_of_subunits;
      this.status = this.model.status > 0;
    }
  },
  methods: {
    async validateData() {
        this.validationErrors = {};
        if (this.name === undefined || this.name === "") this.validationErrors['name'] = 'Nhập loại đơn vị';
        this.name_exists = await this.checkName();
    },
    async checkName() {
        this.name = this.name.trim();
        if (this.name !== undefined && this.name !== "") {
            var where = { name: {'_ilike': this.name} }
            if (this.model !== undefined) where = Object.assign(where, {id: {'_neq': this.model.id}})
            var data = await DataServices.getList(this.modelName, {"fields": "id", "variables": JSON.stringify({where_key: where})});
            return data && data[Object.keys(data)].length > 0
        }
    },
    async saveData() {
        this.submitForm = true;
        await this.validateData();
        if (!this.name_exists && Object.entries(this.validationErrors).length === 0) {
            var params = {
                'name': this.name,
                'number_of_accounts': (!this.$myConstants.isEmpty(this.number_of_accounts)) ? this.number_of_accounts:0,
                'number_of_subunits': (!this.$myConstants.isEmpty(this.number_of_subunits)) ? this.number_of_subunits:0,
                'status': this.status ? 1 : 0
            }
            if (this.formMode === 'add') {
                params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() })
                params = Object.assign(params, { 'created_date': this.$myConstants.currentDate() })
                await DataServices.insertData(this.modelName, {"variables": JSON.stringify({objects: params})});
                this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Tạo mới thành công', life: 3000 })
                this.displayDialog = false;
                this.$emit('refresh');
            } else {
                params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() })
                await DataServices.updateData(this.modelName, {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.model.id }}})});
                this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
                this.displayDialog = false;
                this.$emit('refresh');
            }
        } else this.submitForm = false;
    }
  }
}
</script>

<style lang="scss" scoped>
</style>